export default __webpack_public_path__ + "static/media/default_user.6818d7b3.svg";